import { Loader2 } from "@/components/icons";

export function SupportAnswerPending() {
  return (
    <p className="flex items-center gap-2 text-sm text-muted-foreground">
      <Loader2 className="size-4 animate-spin motion-reduce:animate-none" />
      Looking through our guides…
    </p>
  );
}
